import React, { createContext, useState, useContext ,useEffect} from 'react';

const DateTimeContext = createContext();

export const useDateTime = () => useContext(DateTimeContext);

export const DateProvider = ({ children }) => {
    const [selectedDate, setSelectedDate] = useState('');
    const [selectTime, setSelectTime] = useState('');
    const [rowSelection, setRowSelection] = useState({});
    const [selectedIds, setSelectedIds] = useState('');
    
    const getSelectedIds = (selectionObject) => {
        return Object.keys(selectionObject).filter((key) => selectionObject[key]);
    };
    useEffect(() => {
        setSelectedIds(getSelectedIds(rowSelection));
        // console.log(selectedIds);
    }, [rowSelection]);
    return (
        <>
        <DateTimeContext.Provider value={{ selectedDate, setSelectedDate, selectTime, setSelectTime ,rowSelection, setRowSelection,selectedIds,setSelectedIds}}>
            {children}
        </DateTimeContext.Provider>
        
        </>
    );
};
